module.exports = __webpack_public_path__ + "static/media/app-store-badge.b0954a5d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/footer/app-store-badge.svg
 ** module id = 2137
 ** module chunks = 44
 **/